import { useMemo, memo } from 'react';
import { type TFunction } from 'i18next';
import Grid from '../Grid';
import Typography from '../Typography';
import { S5, S6 } from '../../theme';
import TypographyWithTooltip from '../TypographyWithTooltip';

interface IDetailsElementsProps {
  elements: object;
  t: TFunction;
  translationKey: string;
  hidden: boolean;
}

const DetailsElements = (props: IDetailsElementsProps) => {
  const {
    elements, t, translationKey, hidden,
  } = props;

  const objectEntries = useMemo(
    () => (hidden ? [] : Object.entries(elements)),
    [hidden, elements],
  );

  if (hidden) {
    return null;
  }

  return (
    <>
      {objectEntries.map(([key, value]) => (
        <Grid key={key} container item xs={12} md={6} flexDirection="column" pr={1}>
          <Typography variant="caption" color={S5} mb={1}>
            {t(`${translationKey}.${key}`)}
          </Typography>
          <TypographyWithTooltip variant="body3" color={S6}>
            {value}
          </TypographyWithTooltip>
        </Grid>
      ))}
    </>
  );
};

export default memo(DetailsElements);
